import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
    selectedKnowledgeFile: string;
}

const initialState: IInitialState = {
    selectedKnowledgeFile: '',
};

const knowledgeGraphSelectedButtonSlice = createSlice({
    name: 'knowledgeGraphSelectedButton',
    initialState,
    reducers: {
        addKnowledgeGraphFile: (state: IInitialState, action: PayloadAction<string>) => {
            state.selectedKnowledgeFile = action.payload;
        },
        removeKnowledgeGraphFile: (state: IInitialState) => {
            state.selectedKnowledgeFile = '';
        },
    },
});

export default knowledgeGraphSelectedButtonSlice.reducer;
export const { addKnowledgeGraphFile, removeKnowledgeGraphFile } = knowledgeGraphSelectedButtonSlice.actions;
